import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import Loader from "@/store/modules/loading.js"
import Usuario from "@/store/modules/usuario.js"

Vue.use(Vuex)

export default new Vuex.Store({
  state: { },
  mutations: { },
  actions: { },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
  })],
  modules: {
    usuario: Usuario,
    loader: Loader,
  }
})
